export function showTip(data, duration = 3000) {
  return new Promise((resolve) => {
    const outter = document.createElement('div');
    outter.setAttribute('class', 'plv-iar-tip');
    const outterStyle = ['position: fixed', 'z-index: 10002', 'top: 0', 'right: 0', 'bottom: 0', 'left: 0'];
    outter.setAttribute('style', outterStyle.join(';'));
    const innerStyle = [
      'position: absolute',
      'top: 50%',
      'left: 50%',
      'transform: translate(-50%, -50%)',
      'width: max-content',
      'padding: 16px',
      'color: #fff',
      'font-size: 16px',
      'line-height: 22px',
      'font-weight: 500',
      'text-align: center',
      'background-color: rgba(0, 0, 0, .8)',
      'border-radius: 4px',
      'max-width: 80vw',
    ];
    outter.innerHTML = `<span style="${innerStyle.join(';')}">${data}</span>`;
    document.body.appendChild(outter);
    outter.onclick = () => {
      document.body.removeChild(outter);
      resolve();
    };
    setTimeout(() => {
      document.body.removeChild(outter);
      resolve();
    }, duration);
  });

}
